import { useTranslation } from 'react-i18next';
import { classNames } from '@utils/classNames';

type NotAnalyzableProps = {
  className?: string;
};

export const NotAnalyzable = ({ className }: NotAnalyzableProps) => {
  const { t } = useTranslation('component', { keyPrefix: 'parameterList' });
  return (
    <span
      className={classNames('text-dark text-sm font-extrabold', className)}
      data-testid="not-analyzable"
    >
      {t('notAnalyzable')}
    </span>
  );
};
